<template>
  <v-system-bar
    v-if="getConfig('ALERT_BANNER_ENABLED')"
    color="secondary"
    class="darken-1 d-flex justify-center"
    dark
    app
    :style="'top: 24px !important;'"
  >
    <span
      ref="draggableContent"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
      style="white-space: nowrap; display: block; text-align: center; cursor: grab; user-select: none; overflow-x: hidden;"
    >
      <a
        class="white--text"
        :href="getConfig('ALERT_BANNER_URL')"
        :target="getConfig('ALERT_BANNER_URL_NEW_WINDOW') ? '_blank' : ''"
        v-if="getConfig('ALERT_BANNER_URL')"
        >{{ getConfig('ALERT_BANNER_MESSAGE') }}</a
      >
      <span v-else>{{ getConfig('ALERT_BANNER_MESSAGE') }}</span>
    </span>
  </v-system-bar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AlertBanner',
  props: {},
  data() {
    return {
      online: true,
      alertBannerInterval: null,
      isDragging: false,
      startX: 0,
      scrollLeftStart: 0,
    }
  },
  methods: {
    alertBannerUpdater() {
      if (this.online) {
        return this.$store.dispatch('fetchConfig').finally(() => {
          this.alertBannerInterval = setTimeout(() => {
            this.alertBannerUpdater()
          }, 5000)
        })
      }
    },
    handleTouchStart(e) {
      const content = this.$refs.draggableContent
      if (!content || content.scrollWidth <= content.clientWidth) return // Only drag if content overflows

      this.isDragging = true
      this.startX = e.touches[0].pageX - content.offsetLeft
      this.scrollLeftStart = content.scrollLeft
      content.style.cursor = 'grabbing' // Change cursor style


    },
    handleTouchMove(e) {
      if (!this.isDragging) return
      e.preventDefault() // Prevent default scroll behavior while dragging horizontally
      const content = this.$refs.draggableContent
      const x = e.touches[0].pageX - content.offsetLeft
      const walk = (x - this.startX) * 1.5 // Multiplier for faster/slower scroll
      content.scrollLeft = this.scrollLeftStart - walk
    },
    handleTouchEnd() {
      if (!this.isDragging) return
      this.isDragging = false
      const content = this.$refs.draggableContent
      if (content) {
         content.style.cursor = 'grab' 

      }
    },
  },
  computed: {
    ...mapGetters(['getConfig']),
  },
  created() {
    window._VMA.$on('AUTH_FAILED', () => {
      clearInterval(this.alertBannerInterval)
      this.online = false
    })
    window._VMA.$on('LOGOUT', (e) => {
      clearInterval(this.alertBannerInterval)
      this.online = false
    })
  },
  beforeDestroy() {
    clearTimeout(this.alertBannerInterval)
  },
  async mounted() {
    await this.$store.dispatch('fetchConfig')
    this.alertBannerUpdater()
  },
}
</script>
